import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { usePageMeta } from '../hooks/usePageMeta';

const SECTIONS = [
  {
    heading: 'What OVERALL WELLBEING is',
    paragraphs: [
      'OVERALL WELLBEING is an educational wellbeing platform. We explain how your body and mind work in clear, practical language and help you build small everyday habits. We are not a healthcare provider.',
    ],
  },
  {
    heading: 'Guidance, not medical advice',
    paragraphs: [
      'Nothing on this site is a diagnosis, a treatment plan or a substitute for personal medical advice. Our guides describe general, evidence-informed approaches that may support wellbeing — they cannot account for your individual medical history. Always speak with a qualified health professional before making significant changes, and never stop or change prescribed medication based on anything you read here.',
    ],
  },
  {
    heading: 'Your account',
    paragraphs: [
      'You are responsible for keeping your sign-in details secure and for the information you enter into your personal space. Please use a password you do not use elsewhere, and sign out on shared devices.',
    ],
  },
  {
    heading: 'Health metrics, calculators and medication records',
    paragraphs: [
      'Calculator results are estimates based on the numbers you enter. They are provided for general information and do not replace professional medical assessment.',
      'Medication records and reminders exist to help you stay organised. They use only the information you enter. We do not recommend medicines, dosages or schedules, and we do not check for interactions. If you have a question about a medicine, a dose or a missed dose, speak with your doctor or pharmacist.',
    ],
  },
  {
    heading: 'Acceptable use',
    paragraphs: ['To keep the platform safe and useful for everyone, please do not:'],
    bullets: [
      'Try to access another member’s account or personal information.',
      'Copy or republish our content for commercial use without permission.',
      'Disrupt, scrape or overload the service.',
    ],
  },
  {
    heading: 'Content and changes',
    paragraphs: [
      'We review and update our guidance over time, so content may change. We may also update these terms; the date below shows when they were last revised.',
    ],
  },
  {
    heading: 'Independence',
    paragraphs: [
      'We do not take sponsorships from supplement or wellness brands, and we do not run advertising. Our guidance is written independently.',
    ],
  },
];

export default function Terms() {
  usePageMeta({
    title: 'Terms of Use | OVERALL WELLBEING',
    description:
      'The terms that apply when you use OVERALL WELLBEING — what the platform is, how our guidance should be used, and your responsibilities as a member.',
    path: '/terms',
  });

  return (
    <LegalLayout
      testId="terms-page"
      eyebrow="Trust & Ethics"
      title="Terms of Use"
      intro="A short, plain-English summary of what OVERALL WELLBEING offers and how to use it safely."
      updated="June 2026"
      sections={SECTIONS}
    />
  );
}
